module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og lulesamisk_sekundærlogo_pos(svart).8d47758e.pdf";